import { FC } from 'react';
import withResponsive from 'v3/common/hooks/withResponsive';
import Mobile from './mobile';
import Web from './web';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const ResponsiveComponent = withResponsive(Mobile, Web);

const { productName } = ApplicationDomainUtility;

const SolutionSection: FC = () => {
  return <ResponsiveComponent productName={productName} />;
};

export default SolutionSection;
